import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取党建排行榜列表
export function listPartyLeaderboard(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/party.listPartyLeaderboard',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
